



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Patient, PatientInfo, PatientsRecord, ChartRecord } from "@/types";
import { MEASUREMENT_STATUS, MEASUREMENT_COLORS } from "@/utils/store-util";
import { Component, Watch } from "vue-property-decorator";
import VueApexCharts from "vue-apexcharts";
import Vue from "vue";
import { getDefaultPagination, getPagination } from "@/utils/store-util";
import http from "@/http/axios";
import {} from "../types";
Vue.use(VueApexCharts);
@Component({
  components: {
    VueApexCharts,
  },
})
export default class RealtimeMonitor extends Vue {
  public loading = false;
  public timer = null;
  public patients: Patient[] = [];
  public patients_record: PatientsRecord[] = [];
  public chart_loading = false;
  public switch1 = true;
  public totalPatients = 0;
  public items: PatientInfo[] = [];
  public pagination = getDefaultPagination();
  public totalPages = 0;
  public currentPage = 1;
  private patientOptions = {
    page: 1,
    q: "",
    order: "asc",
    sort: "",
  };
  private lastSearch = "";
  public DropdownPlace = "";
  public place = {
    branch_name: [],
    index: [],
    shortcode: [],
  };

  public t_chartOptions = [];
  public t_series = [];
  public t_rule = {
    warning: [],
    bad: [],
  };
  public p_rule = {
    warning: [],
    bad: [],
  };
  public s_rule = {
    warning: [],
    bad: [],
  };

  @Watch("DropdownPlace",{immediate:true, deep:true})
  Dropdown(){
    
    this.patientOptions.page = 1;
    this.updateCard();
  }

  @Watch("loading", { immediate: true, deep: true })
  updateData() {
    this.chart_loading = true;
  }
  @Watch("switch1", {immediate: true,deep: true})
  handleswitch(){
    if(this.switch1){
      // this.setPagination(getDefaultPagination());
      // this.getPlaceList().then(()=>{
      //   this.getMeasurementTypes().then(()=>{
      //     this.updateCard();
      //   })
      // })
      //this.realTimeData();
      this.timer = setInterval(()=>{
        this.realTimeData();
      // this.setPagination(getDefaultPagination());
      // this.getPlaceList().then(()=>{
      //   this.getMeasurementTypes().then(()=>{
      //     this.updateCard();
      //   })
      // })
    }, 1000 * 30); //每30秒更新一次
    }else{
      clearInterval(this.timer);
    }
  }
  async created() {
    // 移到 hadleswitch 做
    this.setPagination(getDefaultPagination());
    await this.getPlaceList();
    await this.getMeasurementTypes();
    await this.updateCard();
  }
  
  get layout_patients_record() {
    const layout_patients_record = [];
    let i = 0;
    let temp = [];
    for (const patient of this.patients_record){
      temp.push(patient);
      i++;
      // depends on how many columns
      if(i%6==0){
        layout_patients_record.push(temp);
        temp = [];
      }
    }
    if(i%6 != 0){
      layout_patients_record.push(temp);
      temp = [];
    }
    return layout_patients_record;
  }

  async updateCard() {
    await this.allPatients();
    // await this.updateChart();
  }
  async beforeDestroy() { 
    clearInterval(this.timer);
  } 
  async destroyed() {
    this.clearPatient();
  }
  // 即時資料
  async realTimeData(){
    // this.patients_record = [];
    let request_path = "";
    if(this.DropdownPlace === "" || this.DropdownPlace === undefined){
      request_path = `/users?with=record&q=${this.patientOptions.q}&page=${this.patientOptions.page}&limit=40&sort=name,asc&record=mode%3Afull%7Cfield%3Aall&role=Patient`
    }else{
      request_path = `/users?with=record&q=${this.patientOptions.q}&page=${this.patientOptions.page}&limit=40&sort=name,asc&record=mode%3Afull%7Cfield%3Aall&role=Patient&place=name%3A${this.DropdownPlace}`
    }
    const result = await http.get(
      request_path
    );
    if (result) {
      const data = result.data.data;
      this.patients_record = await this.extractPatientInfo(data.users);
      
    }else{
      console.error(result);
    }
  }

  // 取得所有病人量測資料
  async allPatients() {
    this.loading = true;
    this.clearPatient();
    if (!this.loading) {
      if (this.patientOptions.q !== this.lastSearch) {
        this.patientOptions.page = 1;
        this.lastSearch = this.patientOptions.q;
      }
    }

    let request_path = "";
    if(this.DropdownPlace === "" || this.DropdownPlace === undefined){
      request_path = `/users?with=record&q=${this.patientOptions.q}&page=${this.patientOptions.page}&limit=40&sort=name,asc&record=mode%3Afull%7Cfield%3Aall&role=Patient`
    }else{
      request_path = `/users?with=record&q=${this.patientOptions.q}&page=${this.patientOptions.page}&limit=40&sort=name,asc&record=mode%3Afull%7Cfield%3Aall&role=Patient&place=name%3A${this.DropdownPlace}`
    }
    const result = await http.get(
      request_path
    );
    if (result) {
      const data = result.data.data;
      this.totalPatients = data.total_users;
      this.totalPages = data.total_page;
      this.currentPage = this.patientOptions.page;
      // Extract Table Data
      this.patients_record = await this.extractPatientInfo(data.users);
      const pagination = getPagination(
        this.items,
        this.totalPages,
        this.currentPage
      );
      this.setPagination(pagination);
      // 不用等圖載好(因為沒有圖)
      this.loading = false;
    } else {
      console.error(result);
    }
  }
  
  maskname(name){
    const len = name.length;
    switch (len) {
      case 2:
        name = name.substring(0, 1) + "◯";
        break;
      case 3:
        name =
          name.substring(0, 1) +
          "◯" +
          name.substring(2, 3);
        break;
      case 4:
        name =
          name.substring(0, 1) +
          "◯◯" +
          name.substring(3, 4);
        break;
      default:
        name =
          name.substr(0, 3) +
          "◯".repeat(len - 6 > 0 ? len - 6 : 1) +
          name.substr(len - 3, 3);
        break;
      }
    return name;
  }

  async extractPatientInfo(patients) {
    const patients_record = [];
    const re = /^[0-9][a-zA-Z]/;
    for (const patient of patients) {
      if (patient.user) {
        const len = patient.user.name.length;
        if(patient.user.name.substring(0,2)==='民眾'){
          patient.user.name = patient.user.name.substring(0,3) + this.maskname(patient.user.name.substring(3));
        }
        else if(patient.user.name.substring(0,2)==='院內'){
          patient.user.name = patient.user.name.substring(0,5) + this.maskname(patient.user.name.substring(5));
        }
        else if(!re.test(patient.user.name) || len >= 10){
          patient.user.name = this.maskname(patient.user.name);
        }
        patient.user.place = this.codetoPlace(patient.user);

        if (patient.record.body_temperature.body_temperature.measure_at !== null) {
          patient.record.body_temperature.body_temperature.measure_at = new Date(
            patient.record.body_temperature.body_temperature.measure_at * 1000
          ).toLocaleString('zh-TW',{ hour12: false });
          patient.record.body_temperature.body_temperature.value = Number.parseFloat(
            patient.record.body_temperature.body_temperature.value
          ).toFixed(1);
        }
        if (patient.record.spo2.spO2_highest.measure_at !== null) {
          patient.record.spo2.spO2_highest.measure_at = new Date(
            patient.record.spo2.spO2_highest.measure_at * 1000
          ).toLocaleString('zh-TW',{ hour12: false });
          patient.record.spo2.spO2_highest.value = Number.parseFloat(
            patient.record.spo2.spO2_highest.value
          ).toFixed(0);
        }
        if (patient.record.spo2.spO2_lowest.measure_at !== null) {
          patient.record.spo2.spO2_lowest.measure_at = new Date(
            patient.record.spo2.spO2_lowest.measure_at * 1000
          ).toLocaleString('zh-TW',{ hour12: false });
          patient.record.spo2.spO2_lowest.value = Number.parseFloat(
            patient.record.spo2.spO2_lowest.value
          ).toFixed(0);
        }
        if (patient.record.spo2.pulse_highest.measure_at !== null) {
          patient.record.spo2.pulse_highest.measure_at = new Date(
            patient.record.spo2.pulse_highest.measure_at * 1000
          ).toLocaleString('zh-TW',{ hour12: false });
          patient.record.spo2.pulse_highest.value = Number.parseFloat(
            patient.record.spo2.pulse_highest.value
          ).toFixed(0);
        }
        if (patient.record.spo2.pulse_lowest.measure_at !== null) {
          patient.record.spo2.pulse_lowest.measure_at = new Date(
            patient.record.spo2.pulse_lowest.measure_at * 1000
          ).toLocaleString('zh-TW',{ hour12: false });
          patient.record.spo2.pulse_lowest.value = Number.parseFloat(
            patient.record.spo2.pulse_lowest.value
          ).toFixed(0);
        }
        patients_record.push({
          user: patient,
          // record: await this.patientRecord(patient),
        });
      }
    }
    // sorting
    patients_record.sort(function(a,b){
      return a.user.user.name > b.user.user.name ? 1 : -1;
    })
    return patients_record;
  }

  setPagination(pagination) {
    this.pagination = pagination;
  }

  async getPlaceList() {
    const result = await http.get(`/place`);
    if (result) {
      for (let i = 0; i < result.data.data.place.length; i++) {
        this.place.branch_name.push(result.data.data.place[i].branch_name);
        this.place.index.push(result.data.data.place[i].index);
        this.place.shortcode.push(result.data.data.place[i].shortcode);
      }
    } else {
      console.error(result.data.status);
    }
  }

  codetoPlace(item) {
    if (item.place !== null) {
      const pCode = item.place.split(",");
      for (let i = 0; i < this.place.branch_name.length; i++) {
        if (this.place.shortcode[i] == pCode[0]) {
          if (this.place.index[i] == pCode[1]) {
            return this.place.branch_name[i];
          }
        }
      }
    } else return;
  }

  async getMeasurementTypes(): Promise<TODO> {
    const result = await http.get(`/measurements/types`);
    if (result) {
      const data = result.data.data.measurement_type;
      this.t_rule = this.updateRule(data.body_temperature.rule);
      this.p_rule = this.updateRule(data.pulse_highest.rule);
      this.s_rule = this.updateRule(data.spO2_highest.rule);
    } else {
      console.error(result);
    }
    return result;
  }

  async patientRecord(user: Patient) {
    this.loading = true;
    const result = await http.get(
      `/user/${user.user.uuid}/record?limit=-1&range=7,d`
    );
    const record = {
      body_temperature: [],
    };

    if (result.data.data) {
      const data = result.data.data;
      for (const i in data.records) {
        if (data.records[i].key === "body_temperature") {
          const date = new Date(
            data.records[i].measure_at * 1000
          ).toLocaleString('zh-TW',{ hour12: false });
          data.records[i].measure_at = date.substring(5, date.length - 3);
          record.body_temperature.push({
            measure_at: data.records[i].measure_at,
            value: Number.parseFloat(data.records[i].value).toFixed(2),
          });
        }
      }
      return record;
    } else {
      console.error(result);
    }
  }

  updateRule(rule) {
    const value = {
      warning: [],
      bad: [],
    };

    for (const i in rule) {
      if (rule[i].result === MEASUREMENT_STATUS.WARNING) {
        value.warning.push(rule[i].value);
      } else if (rule[i].result === MEASUREMENT_STATUS.BAD) {
        value.bad.push(rule[i].value);
      }
    }

    return value;
  }

  updateChart() {
    const t_value = [];
    const t_measure_at = [];

    const t_warning = [];
    const t_bad = [];

    for (const i in this.patients_record) {
      t_value[i] = [];
      t_measure_at[i] = [];
      
      t_warning[i] = [];
      t_bad[i] = [];
      
      if (this.patients_record[i].record) {
        for (const j in this.patients_record[i].record.body_temperature) {
          t_value[i][j] = this.patients_record[i].record.body_temperature[j].value;
          t_measure_at[i][j] = this.patients_record[i].record.body_temperature[
            j
          ].measure_at;
          t_warning[i][j] = this.t_rule.warning[0];
          t_bad[i][j] = this.t_rule.bad[0];
        }

        this.t_series[i] = [
          {
            name: "測量值",
            data: t_value[i],
          },
          {
            name: "警告值",
            data: t_warning[i],
          },
          {
            name: "異常值",
            data: t_bad[i],
          }
        ];

        this.t_chartOptions[i] = {
          title: {
            text: "體溫",
            align: "left",
          },
          chart: {
            type: "line",
            width: "100%",
            zoom: {
              enabled: false,
            },
          },
          xaxis: {
            categories: t_measure_at[i],
          },
          yaxis: {
            labels: {
              minWidth: 10,
            },
          },
          zoom: {
            enabled: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            width: [3, 3, 3],
            curve: "straight",
            dashArray: [0, 3, 3],
          },
          markers: {
            size: [6, 0, 0],
            hover: {
              sizeOffset: 10,
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          colors: ["#757575", MEASUREMENT_COLORS[1], MEASUREMENT_COLORS[2]],
          tooltip: {
            enabledOnSeries: [0],
          },
        };
        
      }
    }
    this.loading = false;
  }

  updateSeries(value) {
    const Series = [
      {
        name: "測量值",
        data: value,
      },
      {
        name: "警告值",
        data: [],
      },
      {
        name: "異常值",
        data: [],
      },
    ];
    return Series;
  }

  clearPatient() {
    this.patients = [];
    this.patients_record = [];
    this.items = [];
    this.totalPages = 0;
    this.totalPatients = 0;
    this.pagination = getDefaultPagination();
    this.t_chartOptions = [];
    this.t_series = [];
  }
}
